import React from 'react';
import CarrierAddEditModal from './carriermasters-add-edit';
import { MODAL_TYPES } from 'Feature/components/app-modals';

const { CARRIERS_ADD_EDIT } = MODAL_TYPES;

const CarrierModals = () => {
  return (
    <>
      <CarrierAddEditModal modalId={CARRIERS_ADD_EDIT} />
    </>
  );
};

export default CarrierModals;

